"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMIT_TYPING_INDICATOR = void 0;
exports["default"] = emitTypingIndicator;
var EMIT_TYPING_INDICATOR = 'WEB_CHAT/EMIT_TYPING_INDICATOR';
exports.EMIT_TYPING_INDICATOR = EMIT_TYPING_INDICATOR;
function emitTypingIndicator() {
  return {
    type: EMIT_TYPING_INDICATOR
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJFTUlUX1RZUElOR19JTkRJQ0FUT1IiLCJleHBvcnRzIiwiZW1pdFR5cGluZ0luZGljYXRvciIsInR5cGUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9lbWl0VHlwaW5nSW5kaWNhdG9yLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IEVNSVRfVFlQSU5HX0lORElDQVRPUiA9ICdXRUJfQ0hBVC9FTUlUX1RZUElOR19JTkRJQ0FUT1InO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBlbWl0VHlwaW5nSW5kaWNhdG9yKCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IEVNSVRfVFlQSU5HX0lORElDQVRPUlxuICB9O1xufVxuXG5leHBvcnQgeyBFTUlUX1RZUElOR19JTkRJQ0FUT1IgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLHFCQUFxQixHQUFHLGdDQUFnQztBQUFDQyxPQUFBLENBQUFELHFCQUFBLEdBQUFBLHFCQUFBO0FBRWhELFNBQVNFLG1CQUFtQkEsQ0FBQSxFQUFHO0VBQzVDLE9BQU87SUFDTEMsSUFBSSxFQUFFSDtFQUNSLENBQUM7QUFDSCJ9